"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Tabs_1 = __importDefault(require("@web/common/Tabs"));
(() => {
    const tabsElement = document.getElementById('subscription-faq-tabs');
    if (tabsElement) {
        (0, Tabs_1.default)(tabsElement);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const locationHash = window.location.hash;
    if (urlParams.has('question') && locationHash) {
        const questionNumber = Number(urlParams.get('question'));
        const selectedTabId = locationHash.replace('#', '');
        const tabContentContainer = document.getElementById(selectedTabId);
        const questionContainer = tabContentContainer === null || tabContentContainer === void 0 ? void 0 : tabContentContainer.getElementsByClassName('question-container')[questionNumber - 1];
        if (questionContainer) {
            const showAnswer = questionContainer.querySelector('.question .show-answer');
            const answer = questionContainer.querySelector('.answer');
            window.scrollTo({
                top: 400,
                behavior: 'smooth',
            });
            if (answer && showAnswer) {
                showAnswer.classList.add('hide');
                answer.style.display = 'block';
            }
        }
    }
})();
